// extracted by mini-css-extract-plugin
export default {"Reset":"Reset_Reset__hUjMo","details":"Reset_details__WdYLU","section":"Reset_section__8DEXS","Button":"Reset_Button__pnFi7","Bottom":"Reset_Bottom__Vbc0d"};